<template>
  <v-toolbar
    :fixed="fixedToolbar"
    v-if="toolbar"
    :class="navToolbarScheme"
    :clipped-left="toolbarClippedLeft" height="100px"
    class="orange darken-1"
    app
  >
    <v-toolbar-title v-text="title" class="ml-0 hidden-lg-and-up"></v-toolbar-title>
   
    <img src="/static/SecurytyNewLogo4.png" height="60" />
    <v-spacer></v-spacer>

      <v-toolbar-title center ml-10 >
                <v-flex md8 d-flex justify-content-center>
          <span class="center display-1 white--text  font-weight-light">
           {{title1}}</span>
        </v-flex>
      
        <v-flex class="center display-5 white--text  font-weight-light">
          {{title2}}
        </v-flex>
      </v-toolbar-title>
      <v-toolbar-content>

      </v-toolbar-content>
      <v-spacer></v-spacer>

<!--<img src="/static/logocmc.png" height="60" /> -->
 
  </v-toolbar>
</template>
<script>
//import { authUser } from "@/data/dummyData";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      authUser: {},
      title: "",
      isProductsActive: false,
      title1:" Identificación y Firma del Parte de Viajero",
      title2:"Rellena tus datos en este formulario."
    };
  },
  computed: {
    ...mapGetters({
      navDrawer: "navDrawer",
      toolbarClippedLeft: "toolbarClippedLeft",
      fixedToolbar: "fixedToolbar",
      toolbar: "toolbarVisibility",
      navToolbarScheme: "navToolbarScheme",
      navMiniVarient: "navMiniVarient"
    }),
     langValue: {
      get() {
        return this.$store.getters.currentLang;
      },
      set(value) {
        this.$emit("toggleSubDrawer", value);
        return value;
      }
    }
  },
  mounted() {
    this.authUser = this.$store.getters.userData;
    this.langu = this.langValue
    if (this.langu == "en") {
      this.title1 ="Are you interested in trying CMC Group's O2Digital?";
      this.title2="It won't take long, let's start."
    } 
    else if (this.langu == "it") {
      this.text1 = "";
    }
    //   this.isLoggedIn = this.$store.getters.userLoggedIn
  },
  methods: {
    toggleMiniVariantMode() {
      this.$store.dispatch("toggleMiniVariantMode");
      this.$store.dispatch("toggleMiniVarient");
    },
    showSignature() {
      this.isProductsActive = true;
      this.$router.push({ name: "SignaturePage" });
    },
    showNotification() {
      this.isProductsActive = true;
      this.$router.push({ name: "NotificationPage" });
    },
    showIdentification() {
      this.isProductsActive = true;
      this.$router.push({ name: "IdentificationPage" });
    },
    editProfile() {
      this.isProductsActive = false;
      this.$router.push({ name: "ProfilePage" });
    },
    signOut() {
      this.isProductsActive = false;
      this.$store.commit("setUserLoggedIn", false);
      this.$store.commit("setUserEmail", "");
      this.$store.commit("setUserData", null);
      this.$router.push({ name: "HomePage" });
    }
    // home() {
    //   this.isProductsActive = false;
    // },
    // features() {
    //   this.isProductsActive = false;
    // },
    // api() {
    //   this.isProductsActive = false;
    // },
    // pricing() {
    //   this.isProductsActive = false;
    // },
    // login() {
    //   this.isProductsActive = false;
    // },
    // signUp() {
    //   this.isProductsActive = false;
    // },
    // myProfile() {
    //   this.isProductsActive = false;
    // }
  }
};
</script>

<style scoped>
.mTopLeft10 {
  margin: 0 0 0 10px;
}
</style>
